import type { VendorCategory, VendorSubCategory } from "@/services/vendorCategories";

const DEFAULT_KWS_INSTALLATION_CODE = "KWS_INSTALLATION_DEEP_CLEANING";

export function kwsInstallationCode(): string {
  return (
    (typeof window !== "undefined" &&
      window.config?.VENDOR_CATEGORY_CODES?.KWS_INSTALLATION) ||
    DEFAULT_KWS_INSTALLATION_CODE
  );
}

export function isKwsInstallation(
  facility: { super_category?: string | null } | null | undefined,
): boolean {
  return Boolean(facility?.super_category) && facility!.super_category === kwsInstallationCode();
}

export function majorLabel(
  categories: VendorCategory[] | undefined,
  code: string | null | undefined,
): string | null {
  if (!code) return null;
  return categories?.find((c) => c.code === code)?.label ?? code;
}

export function subCategoriesOf(
  categories: VendorCategory[] | undefined,
  majorCode: string | null | undefined,
): VendorSubCategory[] {
  if (!majorCode) return [];
  return categories?.find((c) => c.code === majorCode)?.sub_categories ?? [];
}

export function subLabel(
  categories: VendorCategory[] | undefined,
  majorCode: string | null | undefined,
  subCode: string | null | undefined,
): string | null {
  if (!subCode) return null;
  const inMajor = subCategoriesOf(categories, majorCode).find((s) => s.code === subCode);
  if (inMajor) return inMajor.label;
  for (const c of categories ?? []) {
    const hit = c.sub_categories.find((s) => s.code === subCode);
    if (hit) return hit.label;
  }
  return subCode;
}
